import { render } from "./Footer.vue?vue&type=template&id=5cd8972e&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=5cd8972e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd8972e"]])

export default __exports__